import request from './request'

export function listTracking(data) {
  return request.post('/production/trackings/list', data)
}
export function getTracking(id) {
  return request.get('/production/trackings/' + id)
}
export function saveTracking(data) {
  return request.post('/production/trackings', data)
}
export function updateTracking(data) {
  return request.post('/production/trackings/update', data)
}
export function deleteTracking(ids) {
  return request.post('/production/trackings/delete', ids)
}
export function previewTrackingIssue(trackingId) {
  return request.get('/production/trackings/' + trackingId + '/issue-preview')
}
export function acceptTracking(data) {
  return request.post('/production/trackings/accept', data)
}
export function unacceptTracking(data) {
  return request.post('/production/trackings/unaccept', data)
}
export function rejectTracking(data) {
  return request.post('/production/trackings/reject', data)
}
